import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
//  Used on ALL setups except for the "Other" placeholder setup

export default function CommonRows() {
   const { handleInputRangeChange, onChange, onChangeErrorDivDefinitions } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <>
         <Row className="mb-2">
            <ColPrompt title={"Std. Efficiency"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.stdEfficiency || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 100, "stdEfficiency")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 100, "stdEfficiency")
                  }
               />
               {errorDivDefinitions.stdEfficiency && <ErrorDiv>1-100</ErrorDiv>}
            </ColValue>
         </Row>
         <Row className="mb-2">
            <ColPrompt title={"Std. Spindle Count"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.stdSpindleCount || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 999, "stdSpindleCount")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 999, "stdSpindleCount")
                  }
               />
               {errorDivDefinitions.stdSpindleCount && <ErrorDiv>1-999</ErrorDiv>}
            </ColValue>
         </Row>
         <Row className="mb-2">
            <ColPrompt title={"Labor Assignment"} bold={true} description={"%"} />
            <ColValue size={4}>
               <Label className="me-2">
                  <Input
                     type="radio"
                     name="laborPercent"
                     value={25}
                     onChange={(e) => {
                        onChange("extendedPropertyJson.laborPct", e.target.value);
                        if (errorDivDefinitions?.counterSwitch)
                           onChangeErrorDivDefinitions("laborPct", false);
                     }}
                     checked={
                        machineSetup.extendedPropertyJson.laborPct === "25" ||
                        machineSetup.extendedPropertyJson.laborPct === 25
                     }
                  />
                  25
               </Label>
               <Label className="me-2">
                  <Input
                     type="radio"
                     name="laborPercent"
                     value={50}
                     onChange={(e) => {
                        onChange("extendedPropertyJson.laborPct", e.target.value);
                        if (errorDivDefinitions?.counterSwitch)
                           onChangeErrorDivDefinitions("laborPct", false);
                     }}
                     checked={
                        machineSetup.extendedPropertyJson.laborPct === "50" ||
                        machineSetup.extendedPropertyJson.laborPct === 50
                     }
                  />
                  50
               </Label>
               <Label className="me-2">
                  <Input
                     type="radio"
                     name="laborPercent"
                     value={75}
                     onChange={(e) => {
                        onChange("extendedPropertyJson.laborPct", e.target.value);
                        if (errorDivDefinitions?.counterSwitch)
                           onChangeErrorDivDefinitions("laborPct", false);
                     }}
                     checked={
                        machineSetup.extendedPropertyJson.laborPct === "75" ||
                        machineSetup.extendedPropertyJson.laborPct === 75
                     }
                  />
                  75
               </Label>
               <Label className="me-2">
                  <Input
                     type="radio"
                     name="laborPercent"
                     value={100}
                     onChange={(e) => {
                        onChange("extendedPropertyJson.laborPct", e.target.value);
                        if (errorDivDefinitions?.counterSwitch)
                           onChangeErrorDivDefinitions("laborPct", false);
                     }}
                     checked={
                        machineSetup.extendedPropertyJson.laborPct === "100" ||
                        machineSetup.extendedPropertyJson.laborPct === 100
                     }
                  />
                  100
               </Label>
            </ColValue>
         </Row>
         <Row className="mb-2">
            <ColPrompt title={"Special Instructions"} bold={true} />
         </Row>
         <Row>
            <Col xxl={{ offset: 1, size: 6 }}>
               <Input
                  type="textarea"
                  className="serviceThreadTextArea"
                  value={machineSetup.instructions || ""}
                  onChange={(e) => onChange("instructions", e.target.value)}
                  style={{ borderRadius: "10px", fontSize: "14px", minHeight: "10vh", }}
               />
            </Col>
         </Row>
      </>
   );
}
